<template>
  <div class="card-box">
    <h4 class="header-title m-t-0 m-b-20">Administration</h4>
    <div class="form-group">
      <label>Dans le parc de :</label>
      <user-select v-on:change="onUserChange" :id="customer.user_id"></user-select>
    </div>
    <div class="form-group">
      <label>Organisation des fiches :</label><br/>
      <el-tree
        :data="customersTree"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        @node-drag-enter="handleDragEnter"
        @node-drag-leave="handleDragLeave"
        @node-drop="handleDrop"
        draggable>
        <div :class="['custom-tree-node', 'node-customer', 'node-customer-' + data.item.id, data.item.id === customer.id ? 'node-customer-self' : 'node-customer-other']" slot-scope="{ node, data }">
          <customer :item="data.item"></customer>
          <customer :item="data.item" present="sources"></customer>
        </div>
      </el-tree>

      <el-button class="m-t-20" type="warning" size="mini" v-on:click="searchMerge()">Rechercher une fusion ...</el-button>
    </div>
  </div>
</template>

<style>
  .custom-tree-node {
    -ms-flex: 1;
    flex: 1;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 14px;
    padding-left: 8px;
    padding-right: 8px;
  }

  .node-customer-self a {
    font-weight: bold;
    color: #f1b53d;
  }
</style>

<script>
  import Customer from '../../../Entities/Customer.vue'
  import UserSelect from '../../../Entities/Selects/UserSelect.vue'
  let $ = window.$

  export default {
    components: {
      UserSelect,
      Customer
    },
    name: 'customer-administration-summary-widget',
    props: ['customer'],
    data () {
      return {
        customers: []
      }
    },
    sync: {
      customers () {
        return {
          name: 'customer',
          onUpdate() {
            this.loadSimilar()
          }
        }
      }
    },
    watch: {
      customer (customer) {
        if (customer) {
          this.loadSimilar()
        }
      }
    },
    created () {
      if (this.customer) {
        this.loadSimilar()
      }
    },
    computed: {
      users () {
        return this.$store.getters['users/all']
      },
      customersTree () {
        let toTree = (customer) => {
          return {
            item: customer,
            children: customer.childs.map(toTree)
          }
        }

        return this.customers.map(toTree)
      }
    },
    methods: {
      loadSimilar () {
        let self = this

        this.$nexus.get('crm2', 'customers/search', {
          params: {
            where: {
              parent_id: 'null',
              name: self.customer.name
            },
            includes: 'childs'
          }
        }).then(response => {
          self.customers = response.data.data
        }, 300)
      },
      onUserChange (id) {
        if (id !== null) {
          id = this.users.find(user => user.id === id).id
        }

        this.$model.customer.api().update(this.customer.id, {
          user_id: id
        })
      },
      searchMerge () {
        this.$model.customer.fire('search', {
          form: {
            name: this.customer.name
          },
          merge: this.customer
        })
      },
      handleDragEnter(draggingNode, dropNode, ev) {
        $('.node-customer-' + dropNode.data.item.id).css('backgroundColor', '#ccc')
      },
      handleDragLeave(draggingNode, dropNode, ev) {
        $('.node-customer-' + dropNode.data.item.id).css('backgroundColor', 'white')
      },
      handleDrop(draggingNode, dropNode, dropType, ev) {
        $('.node-customer').css('backgroundColor', 'white')
        if(dropType === 'before' || dropType === 'after') {
          this.$model.customer.api().update(draggingNode.data.item.id, {
            parent_id: dropNode.data.item.parent_id
          })
        } else {
          this.loadSimilar()
          this.$model.customer.fire('move', {
            from: draggingNode.data.item,
            into: dropNode.data.item
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerAdministrationSummaryWidget.vue?f12d389e